import { useSetUrlSearchParams, useUrlQueryParam } from "utils/url";
import { Recharge } from "./reataurant-card";

export const PREPAIED_TOTAL = "prePaied_total_query_key";

export const useRechargeModel = () => {
  const [{ reCharge, forAnnual }, setModelType] = useUrlQueryParam(["reCharge", "forAnnual"]);

  const setUrlParams = useSetUrlSearchParams();

  const openRecharge = (val: string, forAnnualRecharge: boolean) => {
    setModelType({ reCharge: val, forAnnual: forAnnualRecharge ? '1' : '' });
  };
  const closeRecharge = () => {
    setUrlParams({ reCharge: "", forAnnual: '' });
  };

  return {
    reChargeOpen: !!reCharge,
    reCharge,
    forAnnual: !!forAnnual,
    openRecharge,
    closeRecharge,
  };
};

export const getNumber = (str: string, len: number) => {
  const multipTen = Math.pow(10, len + 1);
  const num = Math.floor(parseFloat(str) * multipTen);
  return (num / multipTen).toFixed(len);
};

export const getMaxNum = (data: Recharge[]) => {
  const totals = data.map((item) => {
    const recharge = item?.recharge || "0";
    const back = item?.back || "0";
    if (recharge === "0") {
      return 0;
    }
    return Math.floor((parseFloat(back) / parseFloat(recharge)) * 100);
  });
  return Math.max.apply(null, totals);
};

export const mockDataChargeList = () => {
  return {
    data: [
      {
        id: Math.floor(Math.random() * 10000) + "1",
        type: "gift_card_deal",
        attributes: {
          name: "Pay $200, Get $50",
          foreign_name: "充值$200, 送$50",
          cash_amount: "200.0",
          bonus_amount: "50.0",
        },
      },
      {
        id: Math.floor(Math.random() * 10000) + "1",
        type: "gift_card_deal",
        attributes: {
          name: "Pay $300, Get $100",
          foreign_name: "充值$300, 送$100",
          cash_amount: "300.0",
          bonus_amount: "100.0",
        },
      },
      {
        id: Math.floor(Math.random() * 10000) + "1",
        type: "gift_card_deal",
        attributes: {
          name: "Pay $400, Get $150",
          foreign_name: "充值$400, 送$150",
          cash_amount: "400.0",
          bonus_amount: "150.0",
        },
      },
    ],
  };
};
